// API Configuration
export const API_BASE_URL =
  (process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL !== '')
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:8000/api';

// CDN Configuration
export const CDN_URL =
  (process.env.REACT_APP_CDN_URL && process.env.REACT_APP_CDN_URL !== '')
    ? process.env.REACT_APP_CDN_URL
    : 'http://localhost:8000';

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
};

// Order Statuses
export const ORDER_STATUSES = [
  'pending',
  'confirmed',
  'processing',
  'shipped',
  'delivered',
  'cancelled',
];

// Payment Statuses
export const PAYMENT_STATUSES = ['pending', 'paid', 'failed'];

// Payment Methods
export const PAYMENT_METHODS = {
  ESEWA: 'esewa',
  KHALTI: 'khalti',
  CASH_ON_DELIVERY: 'cash_on_delivery',
};

// Shipping Methods
export const SHIPPING_METHODS = {
  STANDARD: 'standard',
  EXPRESS: 'express',
};

// Shipping Costs (in Nepalese Rupees)
export const SHIPPING_COSTS = {
  [SHIPPING_METHODS.STANDARD]: 1000,
  [SHIPPING_METHODS.EXPRESS]: 2000, // TBD as per requirements
};

// Shipping Method Labels
export const SHIPPING_LABELS = {
  [SHIPPING_METHODS.STANDARD]: 'Standard Shipping (5-7 business days)',
  [SHIPPING_METHODS.EXPRESS]: 'Express Shipping (2-3 business days)',
};

// Payment Method Labels
export const PAYMENT_LABELS = {
  [PAYMENT_METHODS.ESEWA]: 'Esewa',
  [PAYMENT_METHODS.KHALTI]: 'Khalti',
  [PAYMENT_METHODS.CASH_ON_DELIVERY]: 'Cash on Delivery',
};
